import React, {useEffect} from 'react';
import {useTranslation} from "react-i18next";
import FormInput from "./FormInput";

const FileFieldsSection = (props) => {
    const { values, setFieldValue, errors, touched } = props;
    const { t } = useTranslation();

    return (
        <div className="form-wrapper upload-images-wrap">
            <div className="input-col-wrapper">
                <FormInput label={t('firstFileInputTitle')}
                           type={'file'}
                           accept={"image/png"}
                           helper={t('firstFileInputPlaceholder')}
                           onChange={val => setFieldValue('appleIcon', val)}
                           error={touched.appleIcon && errors.appleIcon}
                           value={values.appleIcon}
                />
                <FormInput label={t('secondFileInputTitle')}
                           type={'file'}
                           accept={"image/png"}
                           helper={t('secondFileInputPlaceholder')}
                           onChange={val => setFieldValue('androidIcon', val)}
                           error={touched.androidIcon && errors.androidIcon}
                           value={values.androidIcon}
                />
                <FormInput label={t('thirdFileInputTitle')}
                           type={'file'}
                           accept={"image/png"}
                           helper={t('thirdFileInputPlaceholder')}
                           onChange={val => setFieldValue('notificationIcon', val)}
                           error={touched.notificationIcon && errors.notificationIcon}
                           value={values.notificationIcon}
                />
                <FormInput label={t('fourthFileInputTitle')}
                           type={'file'}
                           accept={"image/png"}
                           helper={t('fourthFileInputPlaceholder')}
                           onChange={val => setFieldValue('splash', val)}
                           error={touched.splash && errors.splash}
                           value={values.splash}
                />
                <FormInput label={t('fifthFileInputTitle')}
                           type={'file'}
                           accept={"image/png"}
                           helper={t('fifthFileInputPlaceholder')}
                           onChange={val => setFieldValue('logo', val)}
                           error={touched.logo && errors.logo}
                           value={values.logo}
                />
                <FormInput label={t('sixthFileInputTitle')}
                           type={'file'}
                           accept={"image/png"}
                           helper={t('sixthFileInputPlaceholder')}
                           onChange={val => setFieldValue('backgroundImage', val)}
                           error={touched.backgroundImage && errors.backgroundImage}
                           value={values.backgroundImage}
                />
            </div>
        </div>
    );
};

export default FileFieldsSection;